import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'
import { useFilter } from '../../../filter/hook';
import { getPrevFilter, getNextFilter } from '../../../filter/utils/prefetchFilters';

export default function useConsumptionCore() {
  const { filter } = useFilter();

  // Calculer les filtres prev et next pour le préchargement
  const prevFilter = getPrevFilter(filter);
  const nextFilter = getNextFilter(filter);

  // Requêtes principales
  const consunptionQuery = useQuery({
    queryKey: ['consumption', filter],
    queryFn: () => dataAPI.getConsumptionSingleCounter(filter)
  });
  
  const consunptionIndexQuery = useQuery({
    queryKey: ['consumption-index', filter],
    queryFn: () => dataAPI.getConsumptionIndexSingleCounter(filter)
  });
  
  const lastConsumptionQuery = useQuery({
    queryKey: ['consumption-last', filter.device_name],
    queryFn: () => dataAPI.getLastConsumptionSingleCounter(filter)
  });

  const bigConsumersQuery = useQuery({
    queryKey: ['big-consumers'],
    queryFn: () => dataAPI.getBigConsummersRanking()
  });

  // Préchargement des données pour la fenêtre précédente
  useQuery({
    queryKey: ['consumption', prevFilter],
    queryFn: () => dataAPI.getConsumptionSingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000, // Cache pendant 5 minutes
  });

  useQuery({
    queryKey: ['consumption-index', prevFilter],
    queryFn: () => dataAPI.getConsumptionIndexSingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  // Préchargement des données pour la fenêtre suivante
  useQuery({
    queryKey: ['consumption', nextFilter],
    queryFn: () => dataAPI.getConsumptionSingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  useQuery({
    queryKey: ['consumption-index', nextFilter],
    queryFn: () => dataAPI.getConsumptionIndexSingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });
  return {

    filter,

    bigConsumersRankingQuery: {
      data : bigConsumersQuery.data,
      isLoading : bigConsumersQuery.isLoading,
      isSuccess : bigConsumersQuery.isSuccess,
      isError : bigConsumersQuery.isError,
      error : bigConsumersQuery.error,
      refetch : bigConsumersQuery.refetch,
      isRefetching : bigConsumersQuery.isRefetching
    },
    lastConsumptionQuery : {
      data : lastConsumptionQuery.data,
      isLoading : lastConsumptionQuery.isLoading,
      isSuccess : lastConsumptionQuery.isSuccess,
      isError : lastConsumptionQuery.isError,
      error : lastConsumptionQuery.error,
      refetch : lastConsumptionQuery.refetch,
      isRefetching : lastConsumptionQuery.isRefetching
    },
    consunptionQuery : {
      data : consunptionQuery.data,
      isLoading : consunptionQuery.isLoading,
      isSuccess : consunptionQuery.isSuccess,
      isError : consunptionQuery.isError,
      error : consunptionQuery.error,
      refetch : consunptionQuery.refetch,
      isRefetching : consunptionQuery.isRefetching
    },
    consunptionIndexQuery : {
      data : consunptionIndexQuery.data,
      isLoading : consunptionIndexQuery.isLoading,
      isSuccess : consunptionIndexQuery.isSuccess,
      isError : consunptionIndexQuery.isError,
      error : consunptionIndexQuery.error,
      refetch : consunptionIndexQuery.refetch,
      isRefetching : consunptionIndexQuery.isRefetching
    },


  }
}
